import { apiGet, apiBasic } from "./requests";

export const getOrders = (params = null) => {
  let path = "filter-orders";
  return apiGet(path, params);
};

export const getOrderDetails = (id) => {
  let path = "order-detailed/" + id;
  return apiGet(path);
};

export const getAbandonedCarts = (params = null) => {
  let path = "abandoned-shopping-carts";
  return apiGet(path, params);
};

export const getStatisticsOrders = (params = null) => {
  let path = "statistics-orders/";
  return apiGet(path, params);
};

export const createInvoice = (payload) => {
  let path = `create-invoice`;
  return apiBasic(payload, path, "post");
};

export const printTicket = (payload) => {
  let path = `print-new-order`;
  return apiBasic(payload, path, "post");
};

export const printInvoice = (payload) => {
  let path = `print-order`;
  return apiBasic(payload, path, "post");
};

/*********** ORDER EDITION *************/

export const updatePendingOrder = (payload, orderId) => {
  let path = `order/${orderId}/update-pending-order`;
  return apiBasic(payload, path, "patch");
};

export const addProductToPendingOrder = (payload, orderId) => {
  let path = `order/${orderId}/add-product-to-pending-order`;
  return apiBasic(payload, path, "post");
};

export const updateQuantityProductToPendingOrder = (payload, orderId) => {
  let path = `order/${orderId}/update-pending-order-product-quantity`;
  return apiBasic(payload, path, "patch");
};

export const removeProductToPendingOrder = (payload, orderId) => {
  let path = `order/${orderId}/remove-product-from-pending-order`;
  return apiBasic(payload, path, "post");
};
